import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getColorMode } from '../../colorMode';
import { replaceInTemplate } from '../../utils/replace-in-template';
import { generateGUID } from '../../utils/generate-uuid';
import { toastTemplates } from './toast-templates';
var document;

if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
  document = window.document;
}

var EXPAND_AFTER = 5 * 1000;
var timeout;
var expandTimeout;
var globalToastConfig;

var createActionItem = function createActionItem(toastAction) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var text, actionText, actionCallback, id, wrapper;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            text = toastAction.text, actionText = toastAction.actionText, actionCallback = toastAction.actionCallback;
            _context.next = 3;
            return generateGUID();

          case 3:
            id = _context.sent;
            wrapper = document.createElement('div');
            wrapper.classList.add('beacon-toast__action__item');

            if (actionCallback) {
              wrapper.innerHTML = text.length > 0 ? "<p>".concat(text, "</p>") : "";
              wrapper.innerHTML += "<p><a id=\"".concat(id, "\">").concat(actionText, "</a></p>");
            } else if (actionText) {
              wrapper.innerHTML = text.length > 0 ? "<p class=\"beacon-toast__action__item__subtitle\">".concat(text, "</p>") : "";
              wrapper.innerHTML += "<p>".concat(actionText, "</p>");
            } else {
              wrapper.innerHTML = "<p>".concat(text, "</p>");
            }

            if (actionCallback) {
              wrapper.addEventListener('click', actionCallback);
            }

            return _context.abrupt("return", wrapper);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var removeAllChildNodes = function removeAllChildNodes(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
};

var formatToastText = function formatToastText(html) {
  var _a, _b;

  var walletIcon = (_a = globalToastConfig === null || globalToastConfig === void 0 ? void 0 : globalToastConfig.walletInfo) === null || _a === void 0 ? void 0 : _a.icon;
  var walletName = (_b = globalToastConfig === null || globalToastConfig === void 0 ? void 0 : globalToastConfig.walletInfo) === null || _b === void 0 ? void 0 : _b.name;
  var wallet = '';

  if (walletIcon) {
    wallet += "<span class=\"beacon-toast__wallet__container\"><img class=\"beacon-toast__content__img\" src=\"".concat(walletIcon, "\">");
  }

  if (walletName) {
    wallet += "<strong>".concat(walletName, "</strong></span>");
  } else {
    wallet += "Wallet";
  }

  return replaceInTemplate(html, 'wallet', wallet);
};

var getToastHTML = function getToastHTML(config) {
  var text = config.body;
  var html = replaceInTemplate(toastTemplates.default.html, 'text', text);
  html = formatToastText(html);
  return {
    style: toastTemplates.default.css,
    html: html
  };
};
/**
 * Close a toast
 */


var closeToast = function closeToast() {
  return new Promise(function (resolve) {
    var _a;

    globalToastConfig = undefined;
    var wrapper = document.getElementById('beacon-toast-wrapper');

    if (!wrapper) {
      return resolve();
    }

    var elm = (_a = wrapper.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('beacon-toast');

    if (elm) {
      var animationDuration = 300;

      if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
      }

      elm.className = elm.className.replace('fadeIn', 'fadeOut');
      window.setTimeout(function () {
        var parent = wrapper.parentNode;

        if (parent) {
          parent.removeChild(wrapper);
        }

        resolve();
      }, animationDuration);
    } else {
      resolve();
    }
  });
};

var registerClick = function registerClick(shadowRoot, id, callback) {
  var button = shadowRoot.getElementById(id);

  if (button) {
    button.addEventListener('click', function () {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return callback(button);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    });
  }

  return button;
};

var showElement = function showElement(shadowRoot, id) {
  var el = shadowRoot.getElementById(id);

  if (el) {
    el.classList.remove('hide');
    el.classList.add('show');
  }
};

var hideElement = function hideElement(shadowRoot, id) {
  var el = shadowRoot.getElementById(id);

  if (el) {
    el.classList.add('hide');
    el.classList.remove('show');
  }
}; // const showLoader = (): void => {
//   showElement('beacon-toast-loader')
// }


var hideLoader = function hideLoader(shadowRoot) {
  hideElement(shadowRoot, 'beacon-toast-loader');
  showElement(shadowRoot, 'beacon-toast-loader-placeholder');
};

var showExpand = function showExpand(shadowRoot) {
  showElement(shadowRoot, 'beacon-toast-button-expand');
  hideElement(shadowRoot, 'beacon-toast-button-close');
};

var showClose = function showClose(shadowRoot) {
  showElement(shadowRoot, 'beacon-toast-button-close');
  hideElement(shadowRoot, 'beacon-toast-button-expand');
};

var collapseList = function collapseList(shadowRoot) {
  var expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
  var list = shadowRoot.getElementById('beacon-toast-list');

  if (expandButton && list) {
    expandButton.classList.remove('beacon-toast__upside_down');
    list.classList.add('hide');
    list.classList.remove('show');
  }
};

var expandList = function expandList(shadowRoot) {
  var expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
  var list = shadowRoot.getElementById('beacon-toast-list');

  if (expandButton && list) {
    expandButton.classList.add('beacon-toast__upside_down');
    list.classList.remove('hide');
    list.classList.add('show');
  }
};

var expandOrCollapseList = function expandOrCollapseList(shadowRoot) {
  var expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
  var list = shadowRoot.getElementById('beacon-toast-list');

  if (expandButton && list) {
    if (expandButton.classList.contains('beacon-toast__upside_down')) {
      collapseList(shadowRoot);
    } else {
      expandList(shadowRoot);
    }
  }
};

var addActionsToToast = function addActionsToToast(shadowRoot, toastConfig, list) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var actions, actionPromises, actionItems, poweredByBeacon;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            actions = toastConfig.actions;

            if (!(actions && actions.length > 0)) {
              _context4.next = 14;
              break;
            }

            actionPromises = actions.map(function (action) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", createActionItem(action));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
            });
            _context4.next = 5;
            return Promise.all(actionPromises);

          case 5:
            actionItems = _context4.sent;
            actionItems.forEach(function (item) {
              return list.appendChild(item);
            });
            poweredByBeacon = document.createElement('small');
            poweredByBeacon.classList.add('beacon-toast__powered');
            poweredByBeacon.innerHTML = toastTemplates.default.poweredByBeacon;
            list.appendChild(poweredByBeacon);
            showExpand(shadowRoot);
            _context4.next = 16;
            break;

          case 14:
            showClose(shadowRoot);
            collapseList(shadowRoot);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};

var createNewToast = function createNewToast(toastConfig) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var timer, shadowRootEl, shadowRoot, wrapper, _getToastHTML, style, html, styleEl, colorMode, elm, list, openWalletButtonEl, closeButton;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            globalToastConfig = toastConfig;
            timer = toastConfig.timer;
            shadowRootEl = document.createElement('div');
            shadowRootEl.setAttribute('id', 'beacon-toast-wrapper');
            shadowRoot = shadowRootEl.attachShadow({
              mode: 'open'
            });
            wrapper = document.createElement('div');
            _getToastHTML = getToastHTML(toastConfig), style = _getToastHTML.style, html = _getToastHTML.html;
            wrapper.innerHTML = html;
            styleEl = document.createElement('style');
            styleEl.textContent = style;
            shadowRoot.appendChild(wrapper);
            shadowRoot.appendChild(styleEl);

            if (timer) {
              timeout = window.setTimeout(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return closeToast();

                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));
              }, timer);
            }

            document.body.prepend(shadowRootEl);
            colorMode = getColorMode();
            elm = shadowRoot.getElementById("beacon-toast");

            if (elm) {
              elm.classList.add("theme__".concat(colorMode));
            }

            list = shadowRoot.getElementById('beacon-toast-list');

            if (!list) {
              _context10.next = 21;
              break;
            }

            _context10.next = 21;
            return addActionsToToast(shadowRoot, toastConfig, list);

          case 21:
            openWalletButtonEl = shadowRoot.getElementById('beacon-open-wallet');

            if (openWalletButtonEl) {
              if (toastConfig.openWalletAction) {
                openWalletButtonEl.addEventListener('click', function () {
                  if (toastConfig.openWalletAction) {
                    toastConfig.openWalletAction();
                  }
                });
              } else {
                openWalletButtonEl.classList.add('hide');
              }
            }

            if (globalToastConfig.state === 'loading') {
              expandTimeout = window.setTimeout(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                  var expandButton;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          expandButton = shadowRoot.getElementById('beacon-toast-button-expand');

                          if (expandButton && !expandButton.classList.contains('beacon-toast__upside_down')) {
                            expandOrCollapseList(shadowRoot);
                          }

                        case 2:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
              }, EXPAND_AFTER);
            }

            registerClick(shadowRoot, 'beacon-toast-button-done', function () {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return closeToast();

                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              }));
            });
            closeButton = registerClick(shadowRoot, 'beacon-toast-button-close', function () {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return closeToast();

                      case 2:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));
            });

            if (closeButton && globalToastConfig.state === 'loading') {
              closeButton.classList.add('hide');
            }

            registerClick(shadowRoot, 'beacon-toast-button-expand', function () {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        expandOrCollapseList(shadowRoot);

                      case 1:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              }));
            });

          case 28:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};

var updateToast = function updateToast(toastConfig) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var timer, wrapper, shadowRoot, list, toastTextEl, openWalletButtonEl, doneButton;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            globalToastConfig = Object.assign(Object.assign({}, globalToastConfig), toastConfig);
            timer = toastConfig.timer;
            wrapper = document.getElementById('beacon-toast-wrapper');

            if (wrapper) {
              _context14.next = 5;
              break;
            }

            return _context14.abrupt("return");

          case 5:
            shadowRoot = wrapper.shadowRoot;

            if (shadowRoot) {
              _context14.next = 8;
              break;
            }

            return _context14.abrupt("return");

          case 8:
            list = shadowRoot.getElementById('beacon-toast-list');

            if (!list) {
              _context14.next = 13;
              break;
            }

            removeAllChildNodes(list);
            _context14.next = 13;
            return addActionsToToast(shadowRoot, toastConfig, list);

          case 13:
            if (globalToastConfig.state === 'loading') {
              expandTimeout = window.setTimeout(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                  var expandButton;
                  return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          expandButton = shadowRoot.getElementById('beacon-toast-button-expand');

                          if (expandButton && !expandButton.classList.contains('beacon-toast__upside_down')) {
                            expandOrCollapseList(shadowRoot);
                          }

                        case 2:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                }));
              }, EXPAND_AFTER);
            }

            toastTextEl = shadowRoot.getElementById('beacon-text-content');

            if (toastTextEl) {
              toastTextEl.innerHTML = formatToastText(toastConfig.body);
            }

            openWalletButtonEl = shadowRoot.getElementById('beacon-open-wallet');

            if (openWalletButtonEl) {
              if (toastConfig.openWalletAction) {
                openWalletButtonEl.classList.remove('hide');
                openWalletButtonEl.addEventListener('click', function () {
                  if (toastConfig.openWalletAction) {
                    toastConfig.openWalletAction();
                  }
                });
              } else {
                openWalletButtonEl.classList.add('hide');
              }
            }

            if (timer) {
              timeout = window.setTimeout(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return closeToast();

                        case 2:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12);
                }));
              }, timer);
            }

            doneButton = shadowRoot.getElementById('beacon-toast-button-done');

            if (doneButton) {
              doneButton.addEventListener('click', function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                  return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          _context13.next = 2;
                          return closeToast();

                        case 2:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13);
                }));
              });
            }

          case 21:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
};
/**
 * Create a new toast
 *
 * @param toastConfig Configuration of the toast
 */


var openToast = function openToast(toastConfig) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var _a, wrapper, shadowRoot;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (expandTimeout) {
              clearTimeout(expandTimeout);
            }

            wrapper = document.getElementById('beacon-toast-wrapper');

            if (!wrapper) {
              _context15.next = 14;
              break;
            }

            if (!toastConfig.forceNew) {
              _context15.next = 10;
              break;
            }

            _context15.next = 6;
            return closeToast();

          case 6:
            _context15.next = 8;
            return createNewToast(toastConfig);

          case 8:
            _context15.next = 12;
            break;

          case 10:
            _context15.next = 12;
            return updateToast(toastConfig);

          case 12:
            _context15.next = 16;
            break;

          case 14:
            _context15.next = 16;
            return createNewToast(toastConfig);

          case 16:
            if (globalToastConfig && globalToastConfig.state === 'finished') {
              shadowRoot = (_a = document.getElementById('beacon-toast-wrapper')) === null || _a === void 0 ? void 0 : _a.shadowRoot;

              if (shadowRoot) {
                hideLoader(shadowRoot);
                showClose(shadowRoot);
                expandList(shadowRoot);
              }
            }

            return _context15.abrupt("return");

          case 18:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
};

export { closeToast, openToast };